import { ServiceType } from '../models';
export class AnalyticsServiceFactory {
    static $inject = ['UserAnalyticsService', 'MessageAnalyticsService', 'EventTrackAnalyticsService'];
    constructor(UserAnalyticsService, MessageAnalyticsService, EventTrackAnalyticsService) {
        this.UserAnalyticsService = UserAnalyticsService;
        this.MessageAnalyticsService = MessageAnalyticsService;
        this.EventTrackAnalyticsService = EventTrackAnalyticsService;
    }
    createService(dimension) {
        switch (dimension) {
            case ServiceType.Users:
                return this.UserAnalyticsService;
            case ServiceType.Messages:
                return this.MessageAnalyticsService;
            case ServiceType.Events:
                return this.EventTrackAnalyticsService;
        }
    }
}
AnalyticsServiceFactory.$inject = ['UserAnalyticsService', 'MessageAnalyticsService', 'EventTrackAnalyticsService'];
